import React, { useCallback } from 'react';
import {
  templatesMarketplaceGalleryPagePageView,
  templatesMarketplaceGalleryPageGenericClick,
} from '@wix/bi-logger-partners-data/v2';
import { useTemplatesContext } from '@components/Contexts/TemplatesContext';
import { useBi } from './useBi';

export const useTemplatesBi = ({ is_mobile }: { is_mobile: boolean }) => {
  const {
    state: { origin, entry },
  } = useTemplatesContext();
  const logger = useBi();

  const logBiPageView = useCallback(() => {
    logger.report(
      templatesMarketplaceGalleryPagePageView({
        ...(is_mobile && { is_mobile }),
        origin,
        entry,
      }),
    );
  }, [is_mobile]);

  const logBiClick = useCallback(
    ({ click_type, click_data }: { click_type: string; click_data?: any }) => {
      logger.report(
        templatesMarketplaceGalleryPageGenericClick({
          origin,
          entry,
          click_type: click_type,
          ...(is_mobile && { is_mobile }),
          ...(click_data && { click_data: JSON.stringify({ click_data }) }),
        }),
      );
    },
    [is_mobile],
  );

  return {
    logBiPageView,
    logBiClick,
  };
};
